import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMenu4 = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "31px",
	height: "43px",
	viewBox: "0 0 31 43",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Material-Design-Stickersheet",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		fontFamily: "Raleway-Medium, Raleway",
		fontSize: 60,
		fontWeight: 400,
		children: /* @__PURE__ */ _jsx("g", {
			id: "Auswertungsbogen-4:-Erz\\xE4hlen",
			transform: "translate(-20.000000, -415.000000)",
			fill: "#FFFFFF",
			children: /* @__PURE__ */ _jsx("text", {
				id: 4,
				children: /* @__PURE__ */ _jsx("tspan", {
					x: 19,
					y: 450,
					children: "4"
				})
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgIconMenu4);
export { ForwardRef as ReactComponent };
